import React, { ReactNode } from "react";
import HoverTooltip from "Components/Common/components/HoverTooltip";

type TooltipOverlayProps = {
    id?: string;
    message: string;
    placement?: "top" | "right" | "bottom" | "left";
    children: ReactNode;
    disabled?: boolean;
    block?: boolean;
};

const TooltipOverlay = ({
    message,
    placement = "top",
    children,
    disabled = false,
    block = false
}: TooltipOverlayProps) => {
    return (
        <HoverTooltip
            text={message}
            position={placement}
            disabled={disabled}
            className={block ? "tw-block tw-w-full" : ""}

        >
            {children}
        </HoverTooltip>
    );
};

export default TooltipOverlay;